export default __webpack_public_path__ + "static/media/wholesale_salesForce_logo.478a367a.png";